import { render, staticRenderFns } from "./delete-modal.vue?vue&type=template&id=c7aa3ff0&scoped=true"
import script from "./delete-modal.vue?vue&type=script&lang=js"
export * from "./delete-modal.vue?vue&type=script&lang=js"
import style0 from "./delete-modal.vue?vue&type=style&index=0&id=c7aa3ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7aa3ff0",
  null
  
)

export default component.exports